<template>
  <div class="tab-block">
    <div class="tab-list" v-if="tabData.list?.length">
      <div
        class="tab-item"
        :class="{
          'tab-active':
            seccode || code
              ? item.categoryCode == seccode || item.categoryCode == code
              : index == 0
        }"
        v-for="(item, index) in tabData.list"
        :key="index"
        @click="changeTab(item, item.categoryCode)"
      >
        <div
          class="tab-hr"
          :class="{
            'tab-hr-active':
              seccode || code
                ? item.categoryCode == seccode || item.categoryCode == code
                : index == 0
          }"
        ></div>
        <div class="tab-item-title">
          <div class="title">{{ item.categoryName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: ['tabData', 'code', 'seccode', 'subcode'],
  data() {
    return {
      isActive: false,
      currentCode: this.code
    }
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile // 假设 isMobile 在根 state 下
    })
  },
  watch: {},
  created() {},
  mounted() {
    // 移动端
    if (this.isMobile) {
      setTimeout(() => {
        this.$nextTick(() => {
          // 找到当前激活的 tab 元素
          const tabList = this.$el.querySelector('.tab-list')
          const tabItems = tabList?.querySelectorAll('.tab-item')
          if (tabItems) {
            // 找到当前点击的 tab 的索引
            const index = this.tabData.list.findIndex(
              (i) => i.categoryCode === this.$route.query.categoryId
            )
            if (index !== -1) {
              tabItems[index].scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
              })
            }
          }
        })
      }, 300)
    }
  },
  methods: {
    //切换栏目
    changeTab(item, tab) {
      this.$emit('changeSecTab', item, tab)
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-block {
  display: flex;
  flex-direction: column;
  .tab-list {
    display: flex;
    flex-direction: column;

    .tab-item {
      display: flex;
      flex-direction: row;
      height: 82.3px;
      cursor: pointer;
      margin-bottom: 34px;
      border-radius: 10px 0 0 10px;
      .tab-hr {
        border-radius: 30px 0 0 30px;
        background: transparent;
        height: 82.3px;
        width: 7px;
      }
      .tab-hr-active {
        background: #1b56a9;
      }
      .tab-item-title {
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex: 1;
        .title {
          display: -webkit-box;
          word-break: break-all;
          text-overflow: ellipsis;
          overflow: hidden;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          color: #333;
          font-size: 24px;
          font-weight: 600;
          margin-left: 24px;
        }
      }
    }
    .tab-item:last-child {
      margin-bottom: 0;
    }
    .tab-item:hover {
      background: rgba(27, 86, 169, 0.12);
      border-radius: 0;
      .tab-item-title {
        .title {
          color: #1b56a9;
          font-weight: 600;
        }
      }
    }

    .tab-active {
      background: rgba(27, 86, 169, 0.12);
      .tab-item-title {
        .title {
          color: #1b56a9;
          font-weight: 600;
        }
      }
    }
  }
}

// 手机端css
.mobile-content {
  .tab-block {
    .tab-list {
      width: 100%;
      display: flex;
      flex-direction: row;
      overflow-x: auto;
      overflow-y: hidden;
      background: linear-gradient(180deg, #e7f2ff 0%, #fff 128.79%);
      .tab-item {
        width: max-content;
        min-width: 110px;
        padding: 0 10px;
        margin-bottom: 0;
        height: 40px;
        position: relative;
        border-radius: 0;
        box-sizing: border-box;
        .tab-hr {
          width: 70px;
          height: 3px;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          margin: 0 auto;
          border-radius: 5px;
        }
        .tab-item-title {
          .title {
            font-size: 16px;
            margin-left: 0;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
